import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Brush,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import { labelFormatterMoneyAsInteger } from '../../../../../shared/formatters/formatters';
import {
  WeightedAverageChartData,
  WeightedAverageEcoMapChartData,
} from './types';

export const WeightedAverageECOMAP: React.FC = () => {
  const { chartsDataPrimary } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  const { requestStatus } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  return (
    <ChartCard
      data={chartsDataPrimary['weightedAverage']}
      Chart={WeightedAverageChart}
      cy={'WeightedAverage'}
      id={'weightedAverage'}
      requestStatus={requestStatus['weightedAverage']}
    />
  );
};

export const WeightedAverageECO: React.FC = () => {
  const { chartsDataPrimary } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  const { requestStatus } = useSelector(
    (state: any) => state.offersPrimaryState
  );

  return (
    <ChartCard
      data={chartsDataPrimary['weightedAverageEcoMap']}
      Chart={WeightedAverageChart}
      cy={'WeightedAverageECO'}
      id={'weightedAverageECO'}
      requestStatus={requestStatus['weightedAverageEcoMap']}
    />
  );
};

export const WeightedAverageMAP: React.FC = () => {
  const { chartsDataPrimary } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  const { requestStatus } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  return (
    <ChartCard
      data={chartsDataPrimary['weightedAverageEcoMap']}
      Chart={WeightedAverageChart}
      cy={'WeightedAverageMAP'}
      id={'weightedAverageMAP'}
      requestStatus={requestStatus['weightedAverageEcoMap']}
    />
  );
};

const WeightedAverageChart: React.FC<
  IChartProps<WeightedAverageChartData[] | WeightedAverageEcoMapChartData[]>
> = ({ data, cy, id }) => {
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [
    labelFormatterMoneyAsInteger,
    labelFormatterMoneyAsInteger,
  ];
  const key = cy.toLowerCase().includes('eco')
    ? 'eco_'
    : cy.toLowerCase().includes('map')
    ? 'map_'
    : '';
  const average =
    data[0][
      `${key}weighted_average_line_${
        data[0]['type' as keyof (typeof data)[0]]
      }s` as keyof (typeof data)[0]
    ];
  return (
    <ResponsiveContainer data-cy={`WeightedAverage${cy}`}>
      <LineChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <Legend iconType="circle" />
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <YAxis dataKey={`${key}weighted_average`} />
        <Line
          type="monotone"
          isAnimationActive={false}
          name="Média ponderada"
          dataKey={`${key}weighted_average`}
          stroke="#492273"
        ></Line>
        <Line
          type="monotone"
          isAnimationActive={false}
          name={`Média do valor/m² das unidades em estoque`}
          dataKey={() => average}
          stroke="red"
        />
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
};
